import React from 'react'
import Helmet from 'react-helmet'
import Layout from '../components/layout'
import Banner from '../components/Banner'
import Contact from '../components/Contact'
import Main from '../components/main'


import pic01 from '../assets/images/markus-spiske-N_TFAu9gtf0-unsplash.jpg' // eslint-disable-line no-unused-vars
import pic02 from '../assets/images/markus-spiske-2VMcpbUR6w8-unsplash.jpg' // eslint-disable-line no-unused-vars
import pic04 from '../assets/images/sharon-mccutcheon-tn57JI3CewI-unsplash.jpg' // eslint-disable-line no-unused-vars
import pic05 from '../assets/images/burst-kUqqaRjJuw0-unsplash.jpg' // eslint-disable-line no-unused-vars

class HomeIndex extends React.Component {
    render() {

        return (
            <Layout>
                <Helmet
                    title="Uczelnie Szkołom – o finansach z NBP"
                    meta={[
                        { name: 'description', content: 'Uczelnie Szkołom – o finansach z NBP' },
                        { name: 'keywords', content: 'uczelnie szkołom, nbp, Podhalańska Państwows Uczelnia Zawodowa, Nowy Targ, Narodowy Bank Polski' },
                    ]}
                >
                </Helmet>

                <Banner />

                <Main />

                <Contact />

            </Layout>
        )
    }
}

export default HomeIndex